import { render } from "./OrderCommentCreateEditDialog.vue?vue&type=template&id=00fba8ba&scoped=true&ts=true"
import script from "./OrderCommentCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./OrderCommentCreateEditDialog.vue?vue&type=script&lang=ts"

import "./OrderCommentCreateEditDialog.vue?vue&type=style&index=0&id=00fba8ba&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fba8ba"]])

export default __exports__